import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './ChemicalPeels.css';

function ChemicalPeels() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'Chemical Peels Treatment | Sapium Beauty - Professional Skin Peels London';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional chemical peels for skin rejuvenation in London. Improve texture, reduce pigmentation, and restore radiance. Safe treatments for all skin types. Book your consultation at Sapium Beauty.');
    }
  }, []);

  return (
    <div className="chemical-peels-page">
      {/* Hero Section */}
      <section className="chemical-peels-hero">
        <div className="container">
          <h1>{t('services.treatments.chemical-peels.title')}</h1>
          <p className="hero-subtitle">{t('services.treatments.chemical-peels.description')}</p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="chemical-peels-content">
        <div className="container">
          <div className="content-wrapper">
            {/* Overview */}
            <div className="content-section">
              <h2>What Are Chemical Peels?</h2>
              <p>
                Chemical peels are professional skincare treatments that use a chemical solution to exfoliate 
                and remove damaged outer layers of the skin. This process reveals smoother, more radiant skin 
                underneath and stimulates the production of new skin cells, resulting in improved texture, 
                tone, and overall appearance.
              </p>
            </div>

            {/* Benefits Section */}
            <div className="content-section">
              <h2>{t('services.labels.benefits')}</h2>
              <ul className="benefits-list">
                {t('services.treatments.chemical-peels.benefits', { returnObjects: true }).map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>

            {/* How It Works */}
            <div className="content-section">
              <h2>How Chemical Peels Work</h2>
              <p>
                During a chemical peel treatment, a carefully selected chemical solution is applied to your skin. 
                The solution works by breaking down the bonds between dead skin cells, allowing them to be easily 
                removed. This process:
              </p>
              <ul className="process-list">
                <li>Removes dead and damaged skin cells from the surface</li>
                <li>Stimulates cell turnover and collagen production</li>
                <li>Improves skin texture and reduces the appearance of imperfections</li>
                <li>Enhances the effectiveness of skincare products by allowing better penetration</li>
              </ul>
            </div>

            {/* Suitable For */}
            <div className="content-section">
              <h2>Who Can Benefit from Chemical Peels?</h2>
              <p>
                Chemical peels are suitable for individuals looking to address various skin concerns, including:
              </p>
              <ul className="suitable-list">
                <li>Fine lines and wrinkles</li>
                <li>Acne and acne scars</li>
                <li>Hyperpigmentation and sun damage</li>
                <li>Uneven skin tone and texture</li>
                <li>Dull or lackluster skin</li>
                <li>Age spots and melasma</li>
              </ul>
            </div>

            {/* Aftercare */}
            <div className="content-section">
              <h2>Aftercare & Recovery</h2>
              <p>
                After your chemical peel treatment, it's important to follow proper aftercare instructions:
              </p>
              <ul className="aftercare-list">
                <li>Avoid direct sun exposure and use a high SPF sunscreen daily</li>
                <li>Keep your skin moisturized with gentle, non-irritating products</li>
                <li>Avoid picking or scratching at peeling skin</li>
                <li>Refrain from using harsh skincare products for the first few days</li>
                <li>Stay hydrated and maintain a healthy skincare routine</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://www.fresha.com/book-now/sapium-beauty-hu8f8ild/all-offer?share=true&pId=2743251" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ChemicalPeels;

